import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { FaPhoneSquareAlt } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";

import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { IoLogoYoutube } from "react-icons/io";
import { TbBrandWhatsappFilled } from "react-icons/tb";
import { FaLinkedin } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

const Contact = () => {

    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        const body = document.body;

        if (location.pathname === "/contact") {
            body.classList.add("home");
        } else {
            body.classList.remove("home");
        }

        return () => body.classList.remove("home");
    }, [location.pathname]);

    return (
        <div className='section contact-section'>
            <div className='container'>
                {/* <h2>Contact</h2> */}
                <div className="primary-panel remove mb-0">
                    <div className='row'>
                        <div className='col-lg-6'>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1779.593456684615!2d81.00506863859613!3d26.86580198688202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be2bef8e5f9d3%3A0xa0cd5cc1e323292c!2sDLF%20MyPad!5e0!3m2!1sen!2sin!4v1693913511068!5m2!1sen!2sin"
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                        <div className='col-lg-6'>
                            <div className='col-right'>
                                <h3>Contact Information</h3>
                                <h5>
                                    <span className="icon-phone"><FaPhoneSquareAlt /></span>
                                    +91 7377378030
                                </h5>
                                <h5>
                                    <span className="icon-mail"><FaEnvelope /></span>
                                    info@rrooms.in
                                </h5>
                                <h5>
                                    <span className="icon-location"><FaLocationDot /></span>
                                    B2-1409, DLF My Pad, VIBHUTI KHAND GOMTI NAGAR, Gomti Nagar, Lucknow, Lucknow, Uttar Pradesh, 226010
                                </h5>

                                <ul>
                                    <li>
                                        <a href="https://www.facebook.com/RROOMSHospitality/" target="_blank"><FaFacebook className="icon-facebook" /></a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/rroomspvtltd/" target="_blank" className="icon-insta"><RiInstagramFill /></a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/channel/UCFZH4rXtrgEl9bBAPy-TtwQ" target="_blank"><IoLogoYoutube className="icon-youtube" /></a>
                                    </li>
                                    <li>
                                        <a href="https://web.whatsapp.com/" target="_blank"><TbBrandWhatsappFilled className="icon-whatsapp" /></a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/in/social-rrooms-3b0567293/" target="_blank"><FaLinkedin className="icon-linkedin" /></a>
                                    </li>
                                    <li>
                                        <a href="https://x.com/" target="_blank"><BsTwitterX className="icon-x" /></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact